<template>
	<b-card no-body>
		<FundDetailsDrawer ref="drawer_fund_details" />
		<b-card-header class="border-0">
			<b-row></b-row>
		</b-card-header>

		<b-col cols="12">
			<b-row class="d-flex align-items-center justify-content-md-between">
				<b-col cols="12" md="8" class="d-md-flex">
					<base-input label="Search" v-model="searchQuery" v-on:input="debouncedHandler" placeholder="Search">
					</base-input>
				</b-col>
				<b-col cols="12" md="4">
					<b-row class="d-flex align-items-center justify-content-md-end">
						<b-col cols="auto" class="mb-3">
							<el-button class="float-right px-3 py-2 mb-2 mb-md-0" type="gray" plain>
								<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
									<path fill="currentColor"
										d="M9 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM6.17 5a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-7.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 0 1 0-2h1.17zM15 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2.83 0a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-1.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 1 1 0-2h7.17zM9 17a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2.83 0a3.001 3.001 0 0 1 5.66 0H19a1 1 0 1 1 0 2h-7.17a3.001 3.001 0 0 1-5.66 0H5a1 1 0 1 1 0-2h1.17z" />
								</svg>
								Filters
							</el-button>
						</b-col>
					</b-row>
				</b-col>
			</b-row>
		</b-col>

		<b-row class="d-flex align-items-center mb-3">
			<b-col cols="12" md="8" class="d-flex">
				<div v-for="(status, index) in statusList" :key="index" :style="{
					borderColor: status.active ? itemBorderColor(status) : 'grey',
					borderWidth: status.active ? '2px' : '1px',
					borderStyle: 'solid',
					color: status.active ? itemBorderColor(status) : 'black'
				}" @click.prevent="setActive(status)" class="rounded text-center cursor-pointer p-3 mx-2">
					<span class="font-weight-500">{{ status.name }}</span><br>
					<span class="font-weight-600">{{ status.value }}</span>
				</div>
			</b-col>
		</b-row>

		<div class="table-listings">
			<el-table ref="multipleTable" :data="tableData" style="width: 100%" @selection-change="selectionChange"
				class="mt-4" v-loading="isTableLoading">
				<el-table-column type="selection" width="45"></el-table-column>

				<el-table-column width="70" class-name="icons-chat">
						<template slot-scope="scope">
							<MessagingBoxButton :type="'invinity_customer'" :profile="scope.row" />
						</template>
				</el-table-column>

				<el-table-column label="Fund Ref. No/ Fund Name" min-width="150">
					<template slot="header" slot-scope="scope">
						<span class="text-break">{{ scope.column.label }}</span>
					</template>
					<template slot-scope="scope">
						<p class="top-line text-primary cursor-pointer"
							@click.prevent="$refs.drawer_fund_details.viewFundDetails()">{{ scope.row.ref_no }}</p>
						<p class="bottom-line">{{ scope.row.fund_name }}</p>
					</template>
				</el-table-column>

				<el-table-column label="Name/ Profile &amp; ID" min-width="150">
					<template slot="header" slot-scope="scope">
						<span class="text-break">{{ scope.column.label }}</span>
					</template>
					<template slot-scope="scope">
						<div>
							<div class="d-flex align-items-center">
								<el-tooltip effect="dark" placement="right">
									<div slot="content" class="d-flex align-items-center">
										{{ scope.row.name }}
										<svg xmlns="http://www.w3.org/2000/svg" class="cursor-pointer ml-2"
											@click.prevent="copyToClipboard(scope.row.name)" width="14" height="18" viewBox="0 0 448 512">
											<path fill="currentColor"
												d="M208 0h124.1C344.8 0 357 5.1 366 14.1L433.9 82c9 9 14.1 21.2 14.1 33.9V336c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48zM48 128h80v64H64v256h192v-32h64v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48z" />
										</svg>
									</div>
									<router-link :to="'/funds_management/investors_profile/detail?active=overview'">
										<p class="top-line text-primary">{{ scope.row.name }}</p>
									</router-link>
								</el-tooltip>
							</div>
						</div>
						<b-badge class="bg-gray">{{ scope.row.profile }}</b-badge>
						<span class="bottom-line ml-2">{{ scope.row.profile_id }}</span>
					</template>
				</el-table-column>

				<el-table-column label="Status/ Payment Type" min-width="150">
					<template slot="header" slot-scope="scope">
						<span class="text-break">{{ scope.column.label }}</span>
					</template>
					<template slot-scope="scope">
						<p class="top-line text-warning">{{ scope.row.status }}</p>
						<p class="bottom-line">{{ scope.row.payment_type }}</p>
					</template>
				</el-table-column>

				<el-table-column label="Payment Date/ Days Left" min-width="150">
					<template slot="header" slot-scope="scope">
						<span class="text-break">{{ scope.column.label }}</span>
					</template>
					<template slot-scope="scope">
						<p class="top-line">{{ scope.row.payment_date }}</p>
						<div class="d-flex justify-content-start align-items-center">
							<svg xmlns="http://www.w3.org/2000/svg" class="mr-2" width="12" height="12" viewBox="0 0 512 512">
								<path fill="currentColor"
									d="M464 256a208 208 0 1 1-416 0 208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0zm232-136v136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z" />
							</svg><br>
							<span class="bottom-line">{{ scope.row.days_left }}</span>
						</div>
					</template>
				</el-table-column>

				<el-table-column label="Payment Amt./ Tenure" min-width="150">
					<template slot="header" slot-scope="scope">
						<span class="text-break">{{ scope.column.label }}</span>
					</template>
					<template slot-scope="scope">
						<p class="top-line">RM {{ scope.row.payment_amt | moneyFormatter }}</p>
						<p class="bottom-line">{{ scope.row.tenure }}</p>
					</template>
				</el-table-column>

				<el-table-column label="Monthly Earnings/ OR No." min-width="150">
					<template slot="header" slot-scope="scope">
						<span class="text-break">{{ scope.column.label }}</span>
					</template>
					<template slot-scope="scope">
						<p class="top-line">{{ scope.row.monthly_earnings }}</p>
						<p class="bottom-line">{{ scope.row.or_no }}</p>
					</template>
				</el-table-column>

				<el-table-column fixed="right" width="25" align="center" class-name="px-0">
					<template>
						<el-dropdown trigger="click" style="cursor: pointer">
							<p class="el-dropdown-link mb-0 top-line">
								<b-icon icon="three-dots-vertical" scale="1.5"></b-icon>
							</p>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item>
									<!-- Eye Icon -->
									<svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 576 512">
										<path fill="#13663E"
											d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4 142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1 3.3-7.9 3.3-16.7 0-24.6-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm144-64c0 35.3-28.7 64-64 64-7.1 0-13.9-1.2-20.3-3.3-5.5-1.8-11.9 1.6-11.7 7.4.3 6.9 1.3 13.8 3.2 20.7 13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1-5.8-.2-9.2 6.1-7.4 11.7 2.1 6.4 3.3 13.2 3.3 20.3z" />
									</svg>
									View Change Log
								</el-dropdown-item>
								<el-dropdown-item>
									<span class="text-danger">
										<!-- Trash-Can Icon -->
										<svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 576 512">
											<path fill="#DF3030"
												d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z" />
										</svg>
										Delete
									</span>
								</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</b-card>
</template>
<script>
import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Tooltip, Select, Option, Button } from 'element-ui'
import FundDetailsDrawer from '@/views/FundsMgmt/FundMgmtDrawers/FundDetailsDrawer'
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
import { debounce } from '@/assets/js/httpImports.js'
import MessagingBoxButton from '@/views/Messaging/MessagingBoxButton'

export default {
	mixins: [clientPaginationMixin],
	components: {
		MessagingBoxButton,
		FundDetailsDrawer,
		[Select.name]: Select,
		[Option.name]: Option,
		[Tooltip.name]: Tooltip,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		[Dropdown.name]: Dropdown,
		[DropdownItem.name]: DropdownItem,
		[DropdownMenu.name]: DropdownMenu,
		[Button.name]: Button,
	},
	data() {
		return {
			propsToSearch: [''],
			pending_only: false,
			currentPage: 1,
			mode: 'listing',
			selectedRows: [],
			searchText: '',
			debouncedHandler: '',
			TableColumn: [{
				type: 'selection'
			}],
			isTableLoading: false,
			isFixed: true,
			statusList: [
				{ name: 'All', value: 3, active: false },
				{ name: 'Payment Out', value: 1, active: false },
				{ name: 'Payment In', value: 0, active: false },
				{ name: 'Referral Fee', value: 0, active: false },
			],
			tableData: [
				{
					ref_no: 'ICSB_JVF-#003119',
					fund_name: 'JV Fund 1.0 - 15%',
					name: 'Edward Jo',
					profile: 'Investor',
					profile_id: 3619,
					status: 'Pending Approval',
					payment_type: 'Payment Out',
					payment_date: '27 Jul 2024',
					days_left: '60d',
					payment_amt: 4800,
					tenure: '2nd 6 months',
					monthly_earnings: '7.5%',
					or_no: 'IJVF/2023119'
				}
			]
		}
	},
	mounted() {
		this.debouncedHandler = debounce(() => {
			// this.searchFinancialProposalList();
		}, 500);
	},
	methods: {
		paginationChanged(page) {
			this.pagination.currentPage = page
		},
		selectionChange(selectedRows) {
			this.selectedRows = selectedRows
		},
		copyToClipboard(value) {
			const tempInput = document.createElement('input');
			tempInput.value = value;
			document.body.appendChild(tempInput);
			tempInput.select();
			document.execCommand('copy');
			document.body.removeChild(tempInput);

			_gNotif.notifySuccess(value + '<br>Copied to Clipboard.')
		},
		setActive(clickedStatus) {
			this.statusList.forEach(status => {
				status.active = status === clickedStatus;
			});

			if (clickedStatus.active) {
				this.activeBorder = this.itemBorderColor(clickedStatus);
			} else {
				this.activeBorder = '';
			}
		},
		itemBorderColor(item) {
			// Define the mapping of names to border colors
			const colorMap = {
				All: '#13663E',
				'Payment Out': '#DF3030',
				'Payment In': '#0BC196',
				'Referral Fee': '#73839C',
			};

			// Return the corresponding border color for the current item
			return colorMap[item.name] || 'grey';
		},
	}
}
</script>